var addSuperscript = function (text) { return text.replace(/\^(.*?)\^/g, '<sup>$1</sup>'); };
var getSize = function (sizeType, text) { var _a; return (_a = new RegExp("".concat(sizeType, "=([0-9]{0,})")).exec(text)) === null || _a === void 0 ? void 0 : _a[1]; };
var addVimeoVideo = function (text) {
    return text.replace(/{{vimeo id=(.*?)\s?((w|h)=.*?)?}}/g, function (_entireMatch, videoId, sizes) {
        if (sizes === void 0) { sizes = 'h=340 w=600'; }
        var height = getSize('h', sizes);
        var width = getSize('w', sizes);
        var videoUrl = "https://player.vimeo.com/video/".concat(videoId);
        var widthProp = width ? "width=\"".concat(width, "\"") : '';
        var heightProp = height ? "height=\"".concat(height, "\"") : '';
        var srcProp = "src=\"".concat(videoUrl, "\"");
        var props = [srcProp, widthProp, heightProp].join(' ');
        return "<br/><iframe ".concat(props, " allowfullscreen frameBorder=\"0\" /><br />");
    });
};

export { addSuperscript, addVimeoVideo };
//# sourceMappingURL=customRules.esm.js.map
